import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOhgarTextStaticBannerComponent } from './custom-ohgar-text-static-banner.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CustomOhgarTextStaticBannerComponent],
  exports: [CustomOhgarTextStaticBannerComponent],
    imports: [
        CommonModule,
        I18nModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                OhgarTextStaticBannerComponent: {
                    component: CustomOhgarTextStaticBannerComponent,
                },
            },
        } as CmsConfig),
        RouterModule,
    ]
})
export class CustomOhgarTextStaticBannerModule { }
